import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://public.readdy.ai/ai/img_res/db8e477071ab4bd4f1c40f761b2e2864.jpg)'
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>
        
        <div className="absolute bottom-4 right-4 text-white text-xs opacity-60 z-10">
          ＜イメージ＞
        </div>
        
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto w-full">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            会社概要
          </h1>
          <p className="text-lg md:text-xl opacity-95">
            再生医療の未来を切り拓く、Exosome Oneの企業情報
          </p>
        </div>
      </section>

      {/* Company Information Section */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-2xl shadow-xl p-8 md:p-12">
            <h2 className="text-3xl font-bold mb-8 text-gray-800 text-center">
              会社情報
            </h2>
            
            <div className="space-y-6">
              <div className="flex flex-col md:flex-row md:items-start border-b border-gray-200 pb-6">
                <div className="md:w-1/3 mb-2 md:mb-0">
                  <h3 className="text-lg font-bold text-gray-700">会社名</h3>
                </div>
                <div className="md:w-2/3">
                  <p className="text-gray-800 font-medium">株式会社ミション</p>
                  <p className="text-sm text-gray-600 mt-1">Mission Co., Ltd.</p>
                </div>
              </div>

              <div className="flex flex-col md:flex-row md:items-start border-b border-gray-200 pb-6">
                <div className="md:w-1/3 mb-2 md:mb-0">
                  <h3 className="text-lg font-bold text-gray-700">代表取締役</h3>
                </div>
                <div className="md:w-2/3">
                  <p className="text-gray-800 font-medium">福井 秀延</p>
                </div>
              </div>

              <div className="flex flex-col md:flex-row md:items-start border-b border-gray-200 pb-6">
                <div className="md:w-1/3 mb-2 md:mb-0">
                  <h3 className="text-lg font-bold text-gray-700">所在地</h3>
                </div>
                <div className="md:w-2/3">
                  <p className="text-gray-800">〒559-0034</p>
                  <p className="text-gray-800">大阪府大阪市住之江区南港北１丁目29-1 大阪ベイレジデンス1405</p>
                </div>
              </div>

              <div className="flex flex-col md:flex-row md:items-start border-b border-gray-200 pb-6">
                <div className="md:w-1/3 mb-2 md:mb-0">
                  <h3 className="text-lg font-bold text-gray-700">電話番号</h3>
                </div>
                <div className="md:w-2/3">
                  <p className="text-gray-800">
                    <a href="tel:09036771000" className="hover:text-teal-600 transition-colors cursor-pointer">
                      090-3677-1000
                    </a>
                  </p>
                </div>
              </div>

              <div className="flex flex-col md:flex-row md:items-start">
                <div className="md:w-1/3 mb-2 md:mb-0">
                  <h3 className="text-lg font-bold text-gray-700">メールアドレス</h3>
                </div>
                <div className="md:w-2/3">
                  <p className="text-gray-800">
                    <a href="mailto:info@exosome.one" className="hover:text-teal-600 transition-colors cursor-pointer">
                      info@exosome.one
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold mb-8 text-gray-800 text-center">
            アクセス
          </h2>
          
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="aspect-video">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3282.8234567890123!2d135.41234567890123!3d34.65432109876543!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e8d5e5e5e5e5%3A0x5e5e5e5e5e5e5e5e!2z44Kz44K544Oi44K544Kv44Ko44Ki6aeF!5e0!3m2!1sja!2sjp!4v1234567890123!5m2!1sja!2sjp"
                width="100%" 
                height="100%" 
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <div className="p-6 bg-gradient-to-br from-teal-50 to-blue-50">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-600 rounded-full flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2 text-gray-800">株式会社ミション</h3>
                  <p className="text-gray-700 mb-1">〒559-0034</p>
                  <p className="text-gray-700 mb-3">大阪府大阪市住之江区南港北１丁目29-1 大阪ベイレジデンス1405</p>
                  <div className="text-sm text-gray-600">
                    <p className="mb-1"><strong>最寄駅</strong></p>
                    <p className="mb-1">Osaka Metro中央線 / コスモスクエア駅 徒歩3分</p>
                    <p>Osaka Metro南港ポートタウン線 / コスモスクエア駅 徒歩3分</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold mb-12 text-gray-800 text-center">
            企業理念
          </h2>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-teal-600 to-teal-700 text-white rounded-2xl p-8 shadow-xl">
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full mb-6">
                <i className="ri-eye-line text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Vision</h3>
              <p className="leading-relaxed">
                Exosome Oneは、幹細胞由来エクソソーム（エキソソーム）技術を通じて、
                世界中の人々の健康と美しさに貢献し、
                再生医療・美容医療分野のグローバルリーダーとなることを目指します。
              </p>
            </div>
            
            <div className="bg-gradient-to-br from-blue-600 to-blue-700 text-white rounded-2xl p-8 shadow-xl">
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full mb-6">
                <i className="ri-compass-line text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Mission</h3>
              <p className="leading-relaxed">
                Exosome Oneは、最先端のバイオテクノロジーと厳格な品質管理により、
                安全で効果的なエクソソーム（エキソソーム）製品を提供し、
                医療機関・化粧品メーカーのパートナーとして、
                持続可能な事業成長を支援します。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-teal-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold mb-12 text-gray-800 text-center">
            私たちの価値観
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-6 shadow-lg">
              <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-full mb-4">
                <i className="ri-shield-check-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">品質第一</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                GMPレベルの品質管理体制により、安全性と有効性を徹底的に追求し、
                お客様に信頼される製品を提供します。
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-lg">
              <div className="w-14 h-14 flex items-center justify-center bg-blue-100 rounded-full mb-4">
                <i className="ri-lightbulb-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">革新的技術</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                最先端の研究開発と自動化技術により、
                再生医療の可能性を広げ、業界をリードする存在を目指します。
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-lg">
              <div className="w-14 h-14 flex items-center justify-center bg-purple-100 rounded-full mb-4">
                <i className="ri-team-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">パートナーシップ</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                医療機関、研究機関、企業との強固な連携により、
                共に成長し、社会に貢献する価値を創造します。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-teal-600 to-blue-600 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            お問い合わせ
          </h2>
          <p className="text-lg mb-8 opacity-95">
            Exosome Oneへのご質問やご相談は、お気軽にお問い合わせください。
          </p>
          <a 
            href="/contact" 
            className="inline-flex items-center gap-3 bg-white text-teal-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-colors shadow-xl cursor-pointer whitespace-nowrap"
          >
            <i className="ri-mail-line text-2xl"></i>
            お問い合わせフォーム
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
